import React, { useContext } from 'react'
import styled from 'styled-components'
import { FaTimes } from 'react-icons/fa'
import LinkButton from '../system/forms/link-button'
import { FiltersContext } from './filters'

const ClearButton = styled(LinkButton)`
  display: flex;
  align-items: center;

  span {
    margin-left: ${props => props.theme.spacing.base200};
  }
`

const ClearFiltersButton = ({ ...props }): JSX.Element => {
  const { clear, hasFilters } = useContext(FiltersContext)

  if (!hasFilters) {
    return null
  }

  return (
    <ClearButton onClick={clear} {...props}>
      <FaTimes /> <span>Clear Filters</span>
    </ClearButton>
  )
}

export default ClearFiltersButton
